import {defineStyle, defineStyleConfig} from '@chakra-ui/styled-system';

export default defineStyleConfig({
  variants: {
    'filled-light': defineStyle({
      bg: 'brandColors.greyscale',
      color: 'white',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'brandColors.greyscale',
      borderRadius: '4px',
      padding: '12px 24px',
      display: 'inline-block',
      _hover: {
        bg: 'white',
        color: 'brandColors.greyscale',
        borderColor: 'brandColors.greyscale',
      },
      _active: {
        bg: 'white',
        color: 'brandColors.greyscale',
        borderColor: 'brandColors.greyscale',
      },
      _disabled: {
        bg: 'brandColors.greyscale20',
        color: 'brandColors.greyscale40',
        borderColor: 'brandColors.greyscale20',
        cursor: 'not-allowed',
        opacity: 1,
      },
    }),

    'outlined-light': defineStyle({
      bg: 'white',
      color: 'brandColors.greyscale',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'brandColors.greyscale',
      borderRadius: '4px',
      padding: '12px 24px',
      display: 'inline-block',
      _hover: {
        bg: 'brandColors.greyscale',
        color: 'white',
        borderColor: 'brandColors.greyscale',
      },
      _active: {
        bg: 'brandColors.greyscale',
        color: 'white',
        borderColor: 'brandColors.greyscale',
      },
      _disabled: {
        bg: 'white',
        color: 'brandColors.greyscale30',
        borderColor: 'brandColors.greyscale30',
        cursor: 'not-allowed',
        opacity: 1,
      },
    }),

    'filled-dark': defineStyle({
      bg: 'white', // default: white background
      color: 'brandColors.greyscale', // default: black text
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'brandColors.greyscale', // default: black border (same as text)
      padding: '12px 24px',
      display: 'inline-block',
      borderRadius: '4px',
      _hover: {
        bg: 'brandColors.greyscale', // hover: black background
        color: 'white', // hover: white text
        borderColor: 'white', // hover: white border (same as text)
        _disabled: {
          bg: 'brandColors.greyscale20', // disabled: light gray background
          color: 'brandColors.greyscale40', // disabled: lighter gray text
          borderColor: 'brandColors.greyscale20', // disabled: border same as background
        },
      },
      _active: {
        bg: 'brandColors.greyscale',
        color: 'white',
        borderColor: 'white',
      },
      _disabled: {
        bg: 'brandColors.greyscale20', // disabled: light gray background
        color: 'brandColors.greyscale40', // disabled: lighter gray text
        borderColor: 'brandColors.greyscale20', // disabled: border same as background
        cursor: 'not-allowed',
        opacity: 1,
      },
    }),

    'outlined-dark': defineStyle({
      bg: 'transparent', // default: black background
      color: 'white', // default: white text
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'white', // default: white border (same as text)
      padding: '12px 24px',
      display: 'inline-block',
      borderRadius: '4px',
      _hover: {
        bg: 'white', // hover: white background (same as border)
        color: 'brandColors.greyscale', // hover: black text
        borderColor: 'white', // hover: white border
        _disabled: {
          bg: 'brandColors.greyscale', // disabled: black background
          color: 'whiteAlpha.450', // disabled: lighter gray text
          borderColor: 'whiteAlpha.450', // disabled: lighter gray border (same as text)
        },
      },
      _active: {
        bg: 'white',
        color: 'brandColors.greyscale',
        borderColor: 'white',
      },
      _disabled: {
        bg: 'brandColors.greyscale', // disabled: black background
        color: 'whiteAlpha.450', // disabled: lighter gray text
        borderColor: 'whiteAlpha.450', // disabled: lighter gray border (same as text)
        cursor: 'not-allowed',
        opacity: 1,
      },
    }),
  },
});
